export const MAX_USER_QUERY_LENGTH = 2000;
